// Allows deeper prop setting dynamically.
// e.g. setObjValue(obj, 'user.name', 'john')
export const setObjValue = (obj, prop, value) => {
    const pList = prop.split('.');
    const len = pList.length;
    for (let i = 0; i < len - 1; i++) {
        const elem = pList[i];
        if (!obj[elem]) obj[elem] = {};
        obj = obj[elem];
    }

    obj[pList[len - 1]] = value;
};

export const checkNestedProperty = (obj, ...args) => {
    return args.reduce((obj, level) => obj && obj[level], obj);
};

export const getPropByString = function (o, s) {
    try {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, ''); // strip a leading dot
        const a = s.split('.');
        for (const i = 0, n = a.length; i < n; ++i) {
            const k = a[i];
            if (k in o) {
                o = o[k];
            } else {
                return;
            }
        }
        return o;
    } catch (error) {
        return undefined;
    }
};
